// extracted by mini-css-extract-plugin
export default {"templates":"_25kg_","cbdBannerWrapper":"_2euK5"};